export const RANKING_DATA = {
  DISPLAYED_VEHICLES_NUM: 3,
  MAX_CARS_TO_COMPARE: 4,
  SUBTYPES_TO_COLLAPSE: 3,
  HOW_WE_RANK_VIDEO_ID: 'yDK5n53vQ0g',
  maxRatedVehiclesNum: 10,
  SUBSEGMENTS_WITH_PAYOFF_AD: {
    Convertible: 2,
    Coupe: 3,
    Electric: 2,
    Hybrid: 2,
    Hatchback: 2,
    Minivan: 1,
    Sedan: 7,
    SUV: 11,
    Truck: 3,
    Wagon: 2,
  },
  photoSize: 175,
};
